import { render, staticRenderFns } from "./website-exhibition.vue?vue&type=template&id=554c34b3&scoped=true"
import script from "./website-exhibition.vue?vue&type=script&lang=js"
export * from "./website-exhibition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c34b3",
  null
  
)

export default component.exports